import { useMemo } from 'react';
import { useFim3Api } from '@/components/idea-management/hooks/useFim3Api';
import { OverflowTooltip } from '@/components/ui/OverflowTooltip';
import { CellTextSkeleton } from './withSkeleton';

export const MultiCustomerCell = ({ value }: { value?: number[] }) => {
  const { customersApi } = useFim3Api();
  const { data, isLoading } = customersApi.useGetSome(value ?? []);

  const customersById = useMemo(() => {
    const map = new Map<number, string>();
    for (const c of data?.data ?? []) {
      map.set(c.id, c.name);
    }
    return map;
  }, [data]);

  if (!value?.length) return null;

  if (isLoading && customersById.size === 0) {
    return <CellTextSkeleton />;
  }

  const displayNames = value.map((id) => customersById.get(id) ?? '');
  const joined = displayNames.filter(Boolean).join(', ');

  if (!joined) return null;

  return (
    <div className="flex items-center gap-1 min-w-0">
      <OverflowTooltip
        tooltipContent={<span className="whitespace-pre-wrap">{displayNames.join('\n')}</span>}
      >
        {joined}
      </OverflowTooltip>
    </div>
  );
};
